import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Textarea,
    VStack,
    HStack,
    Text,
    useToast
} from "@chakra-ui/react";
import CommonService from '../../services/CommonService';

import { use, useEffect, useState } from "react";
import RatingSelector from "../../components/RatingSelector";



const PassengerRatingModal = ({
    isOpen,
    onClose,
    DriveNo,
    PassengerID,
    DriverID,
}) => {
    const toast = useToast();
    const [passengerRating, setPassengerRating] = useState(5);
    const [remark, setRemark] = useState("");
    const [loading, setLoading] = useState(false)

    const handleSubmit = async () => {
        setLoading(true)
        const payload = {
            DriveNo,
            Driving: 0,
            Vehicle: 0,
            Driver: 0,
            Passenger: passengerRating,
            Rating_By_UId: DriverID,
            Rating_For_UId: PassengerID,
            Remarks: remark || ""
        };

        try {
            const res = await CommonService.saveDriverRating(payload)
            if (res.statusCode === 200) {
                toast({
                    title: 'Rating Submitted Successfully',
                    status: 'success',
                    duration: 5000, // 10 seconds
                    isClosable: true,
                    position: 'top-right'
                });
                onClose()
            }
        } catch (error) {
            console.error("Error fetching users:", error);
            return false;
        }
        finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        setRemark("")
        setPassengerRating(5)
    }, [isOpen])

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />

            <ModalContent>
                <ModalHeader>Rate Your </ModalHeader>

                <ModalCloseButton />

                <ModalBody>
                    <VStack spacing={5} align="stretch">
                        <RatingSelector
                            label="Passenger Rating"
                            value={passengerRating}
                            onChange={setPassengerRating}
                        />
                        <FormControl>
                            <FormLabel>Remark</FormLabel>
                            <Textarea
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                placeholder="Enter Remark"
                            />
                        </FormControl>
                    </VStack>
                </ModalBody>

                <ModalFooter>
                    <Button mr={3} onClick={onClose}>
                        Close
                    </Button>

                    <Button
                        colorScheme="teal"
                        onClick={handleSubmit}
                        disabled={loading}
                        type="button"
                    >
                        {loading ? "Submitting..." : "Submit"}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default PassengerRatingModal;